export const h1Styles = {
  fontSize: '$36',
  fontWeight: '$semibold',
  lineHeight: '$lineHeight$44',
}

export const h1StylesExtend = {
  fontSize: '$44',
  fontWeight: '$semibold',
  lineHeight: '$lineHeight$66',
}

export const h2Styles = {
  fontSize: '$28',
  fontWeight: '$semibold',
  lineHeight: '$lineHeight$44',
}

export const h2StylesExtend = {
  fontSize: '$36',
  fontWeight: '$semibold',
  lineHeight: '$lineHeight$44',
}

export const h3Styles = {
  fontSize: '$20',
  fontWeight: '$semibold',
  lineHeight: '$lineHeight$30',
}

export const h3StylesExtend = {
  fontSize: '$24',
  fontWeight: '$bold',
  lineHeight: '$lineHeight$32',
}

export const h4Styles = {
  fontSize: '$18',
  fontWeight: '$semibold',
  lineHeight: '$lineHeight$28',
}

export const h5Styles = {
  fontSize: '$16',
  fontWeight: '$medium',
  lineHeight: '$lineHeight$24',
}

export const h6Styles = {
  fontSize: '$14',
  fontWeight: '$medium',
  lineHeight: '$lineHeight$20',
}

export const labelStyles = {
  fontSize: '$14',
  fontWeight: '$medium',
  lineHeight: '$lineHeight$20',
  textAlign: 'left',
  mb: '$8',
  color: '$inputLabel',
}

export const paraStyles = {
  fontSize: '$14',
  fontWeight: '$normal',
  lineHeight: '$lineHeight$20',
  color: '$text',
}

export const paraStylesExtend = {
  fontSize: '$16',
  fontWeight: '$normal',
  lineHeight: '$lineHeight$24',
  color: '$text',
}

export const anchorStyles = {
  'fontSize': '$14',
  'fontWeight': '$medium',
  'lineHeight': '$lineHeight$24',
  'color': '$primaryBase',
  'textDecoration': 'none',
  'cursor': 'pointer',

  '&:hover': {
    color: '$primaryBgHover',
  },
}

export const anchorStylesExtend = {
  'fontSize': '$16',
  'fontWeight': '$semibold',
  'lineHeight': '$lineHeight$24',
  'color': '$primaryBase',
  'textDecoration': 'none',
  'cursor': 'pointer',

  '&:hover': {
    color: '$primaryBgHover',
  },
}

export const ellipsisStyles = {
  'display': '-webkit-box',
  '-webkit-line-clamp': 2,
  '-webkit-box-orient': 'vertical',
  'overflow': 'hidden',
  'text-overflow': 'ellipsis',
}

export const tooltipStyles = {
  fontSize: '$12',
  fontWeight: '$medium',
  lineHeight: '$lineHeight$18',
}

export const helperTextStyles = {
  fontSize: '$12',
  fontWeight: '$normal',
  lineHeight: '$lineHeight$18',
  color: '$gray500',
}
